import axios from "axios";
import { toast } from "sonner";
import { useAuthStore } from "../stores/authStore";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_URL, timeout: 120000 });

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const detail = error.response?.data?.detail || error.message || "Neznámá chyba";
    if (status === 401) {
      useAuthStore.getState().logout();
    } else if (!error.config?.silent) {
      toast.error(typeof detail === "string" ? detail : "Chyba požadavku");
    }
    return Promise.reject(error);
  }
);

export const get = (url, params, cfg) => api.get(url, { params, ...cfg }).then((r) => r.data);
export const post = (url, data, cfg) => api.post(url, data, cfg).then((r) => r.data);
export const put = (url, data, cfg) => api.put(url, data, cfg).then((r) => r.data);
export const patch = (url, data, cfg) => api.patch(url, data, cfg).then((r) => r.data);
export const del = (url, cfg) => api.delete(url, cfg).then((r) => r.data);
